import { useRef } from "react";
import { useUser } from "@clerk/clerk-react";
import { Navigate, useLocation } from "react-router";
import { Loader2 } from "lucide-react";
import { OnboardingChat } from "@/components/onboarding/onboarding-chat";
import { OnboardingShell } from "@/components/onboarding/shell";

/**
 * /get-started — onboarding that begins by creating the account.
 *
 * Only someone already signed in when they arrive is sent on to /onboarding.
 * A visitor who signs in partway through stays here, so the conversation they
 * are in isn't torn down and restarted.
 */
export const CreateSandboxPage = () => {
  const { isSignedIn, isLoaded } = useUser();
  const location = useLocation();
  const signedInOnArrival = useRef<boolean | null>(null);

  if (!isLoaded) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (signedInOnArrival.current === null) signedInOnArrival.current = !!isSignedIn;

  if (signedInOnArrival.current) {
    return <Navigate to={`/onboarding${location.search}`} replace />;
  }

  return (
    <OnboardingShell>
      <OnboardingChat />
    </OnboardingShell>
  );
};
